// src/layout/user/UserMasterLayout.jsx
import React, { useState, useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import UserSidebar from "../../components/useradmin/usersidebar/UserSideBar";
import UserTopNavbar from "../../components/useradmin/usertopnavbar/UserTopNavBar";
import '../../assets/css/useradmin/userMasterlayout/UserMasterLayout.css';
import AppContext from "../../context/AppContext";

const UserMasterLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const {setAuthToken} = useContext(AppContext);
  // Check if screen is mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="user-admin-master-layout">
      <Row className="user-g-0">
        {/* Desktop Sidebar */}
        <Col lg={3} md={4} className={`user-sidebar-col ${isMobile ? 'd-none' : ''}`}>
          <UserSidebar isOpen={false} onClose={closeSidebar} />
        </Col>
        
        {/* Mobile Sidebar - Shown as overlay */}
        {isMobile && (
          <UserSidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
        )} 

        {/* Main Content */}
        <Col lg={9} md={8} sm={12} className="user-content-col">
          <UserTopNavbar 
            onToggleSidebar={toggleSidebar} 
            isSidebarOpen={isSidebarOpen}
          />
          <div className="user-admin-content-wrapper">
            {children}
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default UserMasterLayout;